import type { FunctionPlugin } from 'vue';

import type { SoaConfig } from '@/core/lib/Config';
import { initAuthentication, type Listener } from '@/plugins/authentication/lib/Authentication';

export interface AuthenticationPluginOptions {
  config: SoaConfig;
  listeners?: Listener[];
}

const AuthenticationPlugin: FunctionPlugin<AuthenticationPluginOptions> = function (
  app,
  { config: { authentication }, listeners = [] },
) {
  void (async () => {
    await initAuthentication(authentication, listeners);
  })();
};

export default AuthenticationPlugin;
